import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const stats = [
  { number: '200+', label: 'Lives Impacted', icon: 'ri-heart-line', color: 'text-red-500' },
  { number: '20+', label: 'Families Supported', icon: 'ri-home-heart-line', color: 'text-blue-500' },
  { number: '100+', label: 'Youth Trained', icon: 'ri-graduation-cap-line', color: 'text-purple-500' },
  { number: '60+', label: 'Microloans Issued', icon: 'ri-bank-line', color: 'text-green-500' },
  { number: '100+', label: 'Health Consultations', icon: 'ri-heart-pulse-line', color: 'text-rose-500' },
  { number: '25+', label: 'Communities Reached', icon: 'ri-map-pin-line', color: 'text-amber-500' },
];

const projects = [
  
  {
    year: '2025',
    title: 'Women Economic Empowerment Initiative',
    description: 'Launched a comprehensive Financial Inclusion and skills program specifically targeting women-led households. 200 women received loans averaging UGX 500,000, with a 94% repayment rate, and 180 completed business skills training.',
    outcomes: ['20 women received microloans', '94% repayment rate achieved', '180 completed business training'],
    image: 'https://readdy.ai/api/search-image?query=Ugandan%20women%20entrepreneurs%20business%20market%20empowerment%20smiling%20successful%20group%20outdoor%20colorful%20products&width=700&height=450&seq=81&orientation=landscape',
  },
  {
    year: '2025',
    title: 'Community Health Outreach Campaign',
    description: 'A major health awareness drive in partnership with local health centers. Free medical consultations, HIV testing, and maternal health screenings were provided to over 500 community members across 8 villages in Wakiso District.',
    outcomes: ['50+ free consultations', '8 villages covered', 'HIV testing for 200 individuals'],
    image: 'https://readdy.ai/api/search-image?query=Uganda%20community%20health%20outreach%20medical%20camp%20free%20treatment%20outdoor%20people%20waiting%20caring%20workers&width=700&height=450&seq=82&orientation=landscape',
  },
];

const testimonials = [
  {
    quote: 'The food security program taught us how to grow our own vegetables. My children no longer go to bed hungry.',
    name: 'Florence Nansubuga',
    location: 'Kajjansi Village, Uganda',
    image: 'https://readdy.ai/api/search-image?query=Ugandan%20woman%20farmer%20garden%20smiling%20portrait%20outdoor&width=150&height=150&seq=90&orientation=squarish',
  },
  {
    quote: 'I got a small loan, bought fabric, and started my own clothing business. Today I have three employees.',
    name: 'Agnes Nakibuule',
    location: 'Bulenga, Wakiso District',
    image: 'https://readdy.ai/api/search-image?query=African%20Ugandan%20businesswoman%20tailor%20workshop%20smiling%20confident%20portrait&width=150&height=150&seq=91&orientation=squarish',
  },
  {
    quote: 'After the ICT Training, I now work remotely as a data entry specialist and support my whole family.',
    name: 'Emmanuel Ssali',
    location: 'Entebbe Road, Uganda',
    image: 'https://readdy.ai/api/search-image?query=African%20Ugandan%20young%20man%20IT%20professional%20smiling%20computer%20portrait&width=150&height=150&seq=92&orientation=squarish',
  },
];

export default function ImpactPage() {
  // Gallery
  const galleryImages = [
    { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601124/WhatsApp_Image_2026-07-07_at_18.47.46_aw6c3j.jpg', alt: '' },
      { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601124/WhatsApp_Image_2026-07-08_at_14.03.42_nku8a8.jpg', alt: '' },
      { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601124/WhatsApp_Image_2026-07-09_at_11.58.47_ggesrb.jpg', alt: '' },
      { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601126/WhatsApp_Image_2026-07-09_at_11.58.49_2_bshxsb.jpg', alt: '' },
      { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601126/WhatsApp_Image_2026-07-09_at_11.58.49_nb8d5u.jpg', alt: '' },
      { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601125/WhatsApp_Image_2026-07-09_at_11.58.49_1_flwht1.jpg', alt: '' },
      { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601125/WhatsApp_Image_2026-07-09_at_11.58.48_sqa1iv.jpg', alt: '' },
      { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601125/WhatsApp_Image_2026-07-09_at_11.58.48_1_nhmku1.jpg', alt: '' },
      { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601125/WhatsApp_Image_2026-07-09_at_11.58.48_3_mzmnuk.jpg', alt: '' },
      { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601124/WhatsApp_Image_2026-07-08_at_14.03.42_1_xuvqqn.jpg', alt: '' },
           
     { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1782151234/tailor_ifujit.jpg', alt: '' },
     { src: 'https://res.cloudinary.com/deftrem1m/image/upload/q_auto/f_auto/v1780592398/8_buvank.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/deftrem1m/image/upload/q_auto/f_auto/v1780592398/8_buvank.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/darliwxtt/image/upload/q_auto/f_auto/v1780337640/WhatsApp_Image_2026-06-01_at_17.15.27_nukyff.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/darliwxtt/image/upload/q_auto/f_auto/v1780337740/ch2_scwyjg.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/darliwxtt/image/upload/q_auto/f_auto/v1780337741/WhatsApp_Image_2026-06-01_at_19.53.39_ob5aev.jpg  ', alt: '' },
    { src: 'https://res.cloudinary.com/darliwxtt/image/upload/q_auto/f_auto/v1780337741/WhatsApp_Image_2026-06-01_at_17.15.25_g4xs0l.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1776356874/WhatsApp_Image_2026-04-16_at_18.28.48_cj31o4.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1776317371/6_kch7r6.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1776317375/WhatsApp_Image_2026-04-15_at_13.55.28_lmw5sg.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1776317371/3_vi5u5c.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775380006/sitting-together1_y92fhf.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774804873/sitting-it_bqh1ig.jpg', alt: 'Youth ICT training program' },
    { src: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774804828/c-training_f09mm9.jpg', alt: 'Children in education program' },
    { src: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774351850/profile-pic_s4irka.jpg', alt: 'Community development meeting' },
    { src: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774351696/team-abut-us-update_kfnchp.jpg', alt: 'Women empowerment training session' },
    { src: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774351696/team-together_lm6gqf.jpg', alt: 'Health outreach in progress' },
    { src: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774852063/signature_nva19g.png', alt: 'Sustainable farming practices' },
    { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775055118/msc2_mwkjwh.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775055122/pion_lvnpla.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775055117/guitr2_iufxo7.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775203659/WhatsApp_Image_2026-04-03_at_09.24.57_dj1onf.jpg', alt: '' },
    { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775203659/WhatsApp_Image_2026-04-03_at_09.25.00_bfdbai.jpg', alt: '' },

  ];

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section className="relative h-[50vh] min-h-[360px] flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774853845/top-impact2_vu5rtg.jpg"
            alt="Our Impact"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-[#003366]/75" />
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
          <nav className="text-sm mb-4">
            <Link to="/" className="text-[#ADD8E6] hover:underline cursor-pointer">Home</Link>
            <span className="text-white/50 mx-2">&rsaquo;</span>
            <span className="text-white">Impact</span>
          </nav>
          <h1 className="text-4xl sm:text-5xl font-bold text-white">Our Impact</h1>
          <p className="text-[#ADD8E6] mt-3 text-lg">Measurable Change, Lasting Transformation</p>
        </div>
      </section>

      <main>
        {/* Stats */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 block">By The Numbers</span>
              <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-3">Impact That Counts</h2>
              <p className="text-gray-500 max-w-lg mx-auto">
                Our work is measured not just in numbers, but in the stories of transformation behind each statistic.
              </p>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
              {stats.map((s) => (
                <div key={s.label} className="bg-[#F8F8F8] rounded-xl p-8 text-center hover:border-l-4 hover:border-[#ADD8E6] transition-all duration-200">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 bg-white rounded-full">
                    <i className={`${s.icon} text-2xl ${s.color}`} />
                  </div>
                  <p className="text-4xl font-bold text-[#003366] mb-2">{s.number}</p>
                  <p className="text-gray-500 text-sm uppercase tracking-wide">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Gallery */}
        <section className="bg-[#F8F8F8] py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 block">Visual Stories</span>
              <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-3">Our Gallery</h2>
              <p className="text-gray-500 max-w-lg mx-auto">
                Capturing moments of impact, hope, and transformation across Uganda.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {galleryImages.map((img, index) => (
                <div
                  key={index}
                  className="relative group overflow-hidden rounded-xl aspect-[4/3] cursor-pointer"
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-[#003366]/0 group-hover:bg-[#003366]/40 transition-colors duration-300 flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <i className="ri-eye-line text-white text-3xl" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/*   {/* Projects *
        <section className="bg-[#F8F8F8] py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 block">Featured Work</span>
              <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-3">Recent Projects</h2>
            </div>
            <div className="space-y-0">
              {projects.map((project, index) => (
                <div
                  key={project.title}
                  className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} bg-white`}
                >
                  <div className="w-full lg:w-1/2 h-64 lg:h-80 flex-shrink-0 overflow-hidden">
                    <img src={project.image} alt={project.title} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 p-8 lg:p-12 flex flex-col justify-center">
                    <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-2">Project {project.year}</span>
                    <h3 className="text-2xl font-bold text-[#003366] mb-4">{project.title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed mb-5">{project.description}</p>
                    <ul className="space-y-2">
                      {project.outcomes.map((o) => (
                        <li key={o} className="flex items-center gap-2 text-sm text-gray-600">
                          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                            <i className="ri-checkbox-circle-line text-[#ADD8E6] text-base" />
                          </div>
                          {o}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials *
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <h2 className="text-3xl font-bold text-[#003366] mb-3">Stories of Transformation</h2>
              <p className="text-gray-500 max-w-lg mx-auto">Real voices, real change.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-[#F8F8F8] rounded-xl p-8 text-center">
                  <div className="w-16 h-16 mx-auto rounded-full overflow-hidden mb-4">
                    <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="text-[#ADD8E6] text-3xl font-serif mb-3">&ldquo;</div>
                  <p className="text-gray-600 text-sm leading-relaxed italic mb-5">{t.quote}</p>
                  <p className="font-bold text-[#003366] text-sm">{t.name}</p>
                  <p className="text-[#ADD8E6] text-xs mt-1">{t.location}</p>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* CTA */}
        <section className="bg-[#003366] py-16 text-center">
          <div className="max-w-3xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-white mb-4">Help Us Create More Impact</h2>
            <p className="text-white/70 mb-8">Every donation funds real programs that change real lives across Uganda.</p>
            <Link to="/donate" className="px-10 py-3.5 bg-[#ADD8E6] text-[#003366] font-bold text-base rounded-lg hover:bg-white transition-colors cursor-pointer whitespace-nowrap inline-block">
              Donate Now
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
